<div fxLayout="row wrap" fxLayoutGap="12px" fxLayoutAlign="start center">
    <cipo-text data-testid="search-ai-text" [control]="form.controls['searchText']" fxFlex fxFlex.lt-md="100" />
    <cipo-checkbox
        ngClass.lt-md="m-t-md"
        [control]="form.controls['matchAll']"
        fxFlex.lt-md="46"
        style="white-space: nowrap" />
    @if (contextStore.contracts().length > 1) {
        <cipo-checkbox
            data-testid="search-ai-all-contracts"
            ngClass.lt-md="m-t-md"
            [control]="form.controls['allContracts']"
            fxFlex.lt-md="46"
            style="white-space: nowrap" />
    }
</div>
<!-- For some reason, on first overlay opening, the selects are not working properly (maybe form is initialised later). The defer solves the problem -->
@defer {
    <div fxLayout="row wrap" fxLayoutGap.gt-sm="12px" fxLayoutAlign="start center">
        <cipo-select
            data-testid="search-ai-module"
            class="m-t-md"
            [control]="form.controls['module']"
            fxFlex
            fxFlex.lt-md="100" />
        <cipo-select class="m-t-md" [control]="form.controls['statusType']" fxFlex.lt-md="100" />
        <cipo-select class="m-t-md" [control]="form.controls['period']" fxFlex.lt-md="100" />

        @if (customPeriod()) {
            <cipo-date-time class="m-t-md" [control]="form.controls['dateRange']" fxFlex.lt-md="100" />
        }
    </div>
}
